export default "__VITE_ASSET__BiCU1hYS__"